import React, { useEffect, useRef, useState } from "react";
import { SubNavItem, ListItem, Div, SubMenu } from "./styles";
import { GetNav } from "../../StateManagement/Reducers/ScheduleState";
import { useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "../popups/GetStartedPopup";
import { getHighlightStyles } from "../setting/HighlightConstants";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";

const BillingNav = () => {
  const permission = localStorage.getItem("setroles");
  const decryptedPermission = Decrypt_Value(permission, "vozo");
  const [eobpopup1, seteobpopup1] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const dispatch = useDispatch();
  const location = useLocation();
  const rolesHighlightRef = useRef(null);
  const [isERAIntroOpen, setIsERAIntroOpen] = useState(false);
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const history = useHistory();
  const highlightRef = useRef(null);
  const [isPatientpaymentOpen, setIsPatientpaymentOpen] = useState(
    location.state ? location?.state?.patientpaymentopen : false
  );
  const [isinsclaimOpen, setIsinsclaimOpen] = useState(
    location.state ? location?.state?.insclaimopen : false
  );

  var accountType =
    localStorage.getItem("account_type") &&
    Decrypt_Value(localStorage.getItem("account_type"), "vozo");

  const highlightPatientpayment = useRef(null);
  const highlightinsclaim = useRef(null);

  const highlighteob = useRef(null);
  const handleInputChange = (iconName) => (e) => {
    dispatch(GetNav(iconName));
  };

  const showNextStep = () => {
    setIsERAIntroOpen(false);
    history.replace({
      pathname: location.pathname,
      search: "?step=18.7",
    });
  };

  const goToPreviousStep = () => {
    setIsERAIntroOpen(false);
    history.push({
      pathname: "/billing/eob",
      state: { showPopup5: true },
    });
  };

  const eobpopupnext2 = () => {
    seteobpopup1(false);
    history.push("/billing/eob", { showEobPopup: true });
  };

  useEffect(() => {
    if (isERAIntroOpen && highlightRef.current) {
      setTimeout(() => {
        highlightRef.current.scrollIntoView({
          behavior: "smooth",
          block: "nearest", // Changed from "center" to "nearest"
          inline: "center",
        });
      }, 100);
    }
  }, [isERAIntroOpen]);

  useEffect(() => {
    if (eobpopup1 && rolesHighlightRef.current) {
      if (isInitialLoad) {
        setTimeout(() => {
          setIsInitialLoad(false);
        }, 300);
      }
    }
  }, [eobpopup1, isInitialLoad]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const step = query.get("step");

    if (step === "18.6") {
      setIsERAIntroOpen(true);

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    }
  }, [location?.search]);

  useEffect(() => {
    const handleTrigger = () => {
      seteobpopup1(true);
    };

    window.addEventListener("triggerEobPopup", handleTrigger);

    return () => {
      window.removeEventListener("triggerEobPopup", handleTrigger);
    };
  }, []);

  useEffect(() => {
    if (location.state?.Eobstarted) {
      seteobpopup1(true);
      history.replace(location.pathname, {});
    }
  }, [location.state]);
  useEffect(() => {
    if (location?.state?.patientpaymentopen !== undefined) {
      if (location?.state?.patientpaymentopen === true) {
        window.scrollTo(0, 0);

        setIsPatientpaymentOpen(true);
      } else {
        setIsPatientpaymentOpen(false);
      }
    }
  }, [location?.state?.patientpaymentopen]);
  useEffect(() => {
    if (location?.state?.insclaimopen !== undefined) {
      if (location?.state?.insclaimopen === true) {
        window.scrollTo(0, 0);

        setIsinsclaimOpen(true);
      } else {
        setIsinsclaimOpen(false);
      }
    }
  }, [location?.state?.insclaimopen]);

  useEffect(() => {
    if (location?.state?.insclaimopenfromaccount !== undefined) {
      if (location?.state?.insclaimopenfromaccount === true) {
        window.scrollTo(0, 0);

        setIsinsclaimOpen(true);
      } else {
        setIsinsclaimOpen(false);
      }
    }
  }, [location?.state?.insclaimopenfromaccount]);

  useEffect(() => {
    const isPopupOpen = eobpopup1 || isPatientpaymentOpen;

    if (isPopupOpen) {
      document.body.style.overflow = "hidden"; // disable scroll
    } else {
      document.body.style.overflow = ""; // enable scroll
    }

    return () => {
      document.body.style.overflow = ""; // cleanup on unmount
    };
  }, [eobpopup1, isPatientpaymentOpen]);
  return (
    <Div width="100%" paddingLeft="0.86em">
      <SubMenu textAlign="left" width="100%">
        <ListItem
          padding="8px"
          margin="8px 0 0 0"
          onClick={handleInputChange("iconclose")}
          ref={highlightinsclaim}
          style={
            decryptedPermission.ins_claims && parseInt(accountType) !== 1
              ? { ...getHighlightStyles(isinsclaimOpen) }
              : {}
          }
        >
          <SubNavItem
            to="/billing/insuranceclaim"
            className={
              (splitLocation[1] === "billing" && splitLocation[2] === "nav") ||
              splitLocation[2] === "insuranceclaim"
                ? "active"
                : ""
            }
          >
            Insurance Claims
          </SubNavItem>
        </ListItem>
        {decryptedPermission.ins_claims &&
          isinsclaimOpen &&
          parseInt(accountType) !== 1 && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                zIndex: 50,
              }}
              onClick={() => {
                setIsinsclaimOpen(false);
                history.push({
                  pathname: location.pathname,
                  state: {
                    insclaimopen: false,
                  },
                });
              }}
            />
          )}
        <Popup
          offset={[40, 20]}
          style={{
            zIndex: 9999,
            width: "340px",
          }}
          content={
            <GetStartedPopup
              title="Make a Patient Payment"
              description={
                <div style={{ marginTop: "5px" }}>
                  Go to Billing {">"} Patient Payment menu to process or make
                  payments based on the patients.
                </div>
              }
              currentStep={1}
              totalSteps={7}
              onNext={() => {
                setIsPatientpaymentOpen(false);
                history.replace({
                  pathname: location.pathname,
                  state: {
                    patientpaymentopen: false,
                    patientbalpayopen: true,
                    addpaypopupopen: false,
                  },
                });
                // setTimeout(() => {
                //   setActiveTab("1");
                //   setIsPatientbalpayOpen(true);
                // }, 100);
              }}
              open={decryptedPermission.coding && isPatientpaymentOpen}
              topClose="0px"
              rightClose="3px"
              width="340px"
              onClose={() => {
                setIsPatientpaymentOpen(false);
                // setIsPatientbalpayOpen(false);
                history.replace({
                  pathname: location.pathname,
                  state: {
                    patientpaymentopen: false,
                    patientbalpayopen: false,
                    addpaypopupopen: false,
                  },
                });
              }}
            />
          }
          open={decryptedPermission.coding && isPatientpaymentOpen}
          disabled={!isPatientpaymentOpen}
          trigger={
            <ListItem
              padding="8px"
              margin="0"
              onClick={handleInputChange("iconopen")}
              ref={highlightPatientpayment}
              style={
                decryptedPermission.coding
                  ? {
                      ...getHighlightStyles(isPatientpaymentOpen),
                    }
                  : {}
              }
            >
              <SubNavItem to="/billing/patientpayment" exact>
                Patient Payments
              </SubNavItem>
            </ListItem>
          }
          position="right center"
        />

        {decryptedPermission.coding && isPatientpaymentOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 50,
            }}
            onClick={() => {
              setIsPatientpaymentOpen(false);
              history.push({
                pathname: location.pathname,
                state: {
                  patientpaymentopen: false,
                },
              });
            }}
          />
        )}
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconclose")}
        >
          <SubNavItem to="/billing/patientstatement" exact>
            Patient Statements
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/billing/patientbalance" exact>
            Patient Ledger
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconclose")}
        >
          <SubNavItem to="/billing/feeschedule" exact>
            Fee Schedule
          </SubNavItem>
        </ListItem>
        <Div>
          <ListItem
            padding="8px"
            margin="0"
            onClick={handleInputChange("iconclose")}
          >
            <div
              ref={rolesHighlightRef}
              style={
                decryptedPermission.postPayments && parseInt(accountType) !== 1
                  ? {
                      position: "relative",
                      ...getHighlightStyles(eobpopup1),
                    }
                  : {}
              }
            >
              <Popup
                offset={[35, 156]}
                content={
                  <GetStartedPopup
                    title="Process EOB & ERA Payment"
                    description={
                      <div>
                        Go to Billing {">"} EOB menu to process insurance
                        payment manually.
                      </div>
                    }
                    currentStep={1}
                    totalSteps={10}
                    onNext={() => eobpopupnext2()}
                    width="320px"
                    onClose={() => seteobpopup1(false)}
                  />
                }
                open={
                  decryptedPermission.postPayments &&
                  eobpopup1 &&
                  parseInt(accountType) !== 1
                }
                className=" m-t-10 "
                trigger={
                  <SubNavItem to="/billing/eob" exact>
                    EOB
                  </SubNavItem>
                }
                position="right center"
              />
            </div>
          </ListItem>
        </Div>
        {decryptedPermission.postPayments &&
          eobpopup1 &&
          parseInt(accountType) !== 1 && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                zIndex: 10,
              }}
              onClick={() => seteobpopup1(false)}
            />
          )}
        {/* <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/billing/cardtransactions" exact>
            Card Transactions
          </SubNavItem>
        </ListItem> */}
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <div
            ref={highlightRef}
            style={{
              position: "relative",
              ...getHighlightStyles(isERAIntroOpen),
            }}
          >
            <Popup
              offset={[35, 150]}
              content={
                <GetStartedPopup
                  title="Process EOB & ERA Payment"
                  description={
                    <div>
                      Go to Billing {">"} ERA menu to process insurance payment
                      automatically.
                    </div>
                  }
                  currentStep={6}
                  totalSteps={10}
                  onNext={showNextStep}
                  onBack={goToPreviousStep}
                  onClose={() => setIsERAIntroOpen(false)}
                  width="320px"
                />
              }
              open={isERAIntroOpen}
              className="m-t-10"
              trigger={
                <SubNavItem to="/billing/era" exact>
                  ERA
                </SubNavItem>
              }
              position="right center"
            />
          </div>
        </ListItem>
      </SubMenu>
      {isERAIntroOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 1000,
          }}
          onClick={() => setIsERAIntroOpen(false)}
        />
      )}
    </Div>
  );
};

export default BillingNav;
